// extracted by mini-css-extract-plugin
export var biggy = "component-module--biggy--e40e1";
export var cart = "component-module--cart--0a2a6 component-module--stack--6b21b";
export var cartActions = "component-module--cartActions--a5750 component-module--stack--6b21b";
export var orderTotals = "component-module--orderTotals--5659c";
export var products = "component-module--products--c2764 component-module--stack--6b21b";
export var stack = "component-module--stack--6b21b";